// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TokenSetterSwap-module__defaultOptions___IPmwl{text-align:left}", "",{"version":3,"sources":["webpack://./src/pages/teleport/swap/components/TokenSetterSwap.module.scss"],"names":[],"mappings":"AAAA,gDACE,eAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultOptions": "TokenSetterSwap-module__defaultOptions___IPmwl"
};
export default ___CSS_LOADER_EXPORT___;
